// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"79705377","445":"d9083ded","517":"4634210b","641":"8c1efa5a","688":"4634210b"}[chunkId] + ".chunk.css";
};